export function getKeyString(input: string, maxLength?: number): string {
  // Convert to lowercase
  let formatted = input.toLowerCase();

  // Replace spaces, non-alphabetic, and non-numeric characters with underscores
  formatted = formatted.replace(/[^a-z0-9]/g, "_");

  // Remove leading and trailing underscores
  formatted = formatted.replace(/^_+|_+$/g, "");

  // If maxLength is provided, truncate the result to that length
  if (maxLength !== undefined) {
    formatted = formatted.substring(0, maxLength);
  }

  return formatted;
}

// Avatar utility functions
export function displayName(
  firstName?: string | null,
  lastName?: string | null
): string {
  if (!firstName && !lastName) return "";

  return `${firstName || ""} ${lastName || ""}`.trim();
}

export function nameInitials(name: string): string {
  if (!name) return "?";

  const words = name.trim().split(" ");

  if (words.length === 1) {
    return words[0].charAt(0).toUpperCase();
  }

  return (words[0].charAt(0) + words[words.length - 1].charAt(0)).toUpperCase();
}

export function extractPhotoUrlFromUserInfo(user: any): string | null {
  if (!user || !user.providerData) return null;

  // Check provider data - match Faxify's simple implementation
  for (const providerInfo of user.providerData) {
    if (providerInfo.photoURL) {
      return providerInfo.photoURL;
    }
  }

  return null;
}
